export { buildGroupPathSegments } from "@common/helpers/accounting";

export const GROUP_PATH_SEPARATOR = " › ";
